/**
 * Determines whether a discount code is applicable at a given store.
 *
 * Semantics: an empty `validStoreIds` array means the discount code is not
 * scoped to any specific store and is therefore valid at ALL stores. A
 * non-empty array scopes the code to exactly those stores.
 */
export function isDiscountValidForStore(
    validStoreIds: number[],
    storeId: number | null | undefined,
): boolean {
    if (validStoreIds.length === 0) {
        return true;
    }
    if (storeId == null) {
        return false;
    }
    return validStoreIds.includes(storeId);
}
